import React, {Suspense} from "react";
import {Provider} from "react-redux";
import i18n from "./i18n";
import i18next from "i18next";
import {setLanguage} from "./action/userActions";
import {applyMiddleware, compose, createStore} from "redux";
import thunk from "redux-thunk";
import {rootReducer} from "./redux/rootReducer";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import Loader from "./component/loader";
import {loadState, saveState} from "./redux/utils";
import {createTheme} from "./theme";

// import App from "./App"
const App = React.lazy(() => import("./App"))

const isProduction = process.env.NODE_ENV === "production"

i18n.then(() => {
    !isProduction && console.log("i18n initialized")
    const languageDetected = i18next.language
    console.debug("language detected: " + languageDetected)
    store.dispatch(setLanguage(languageDetected))
})

const composeWithDevtools =
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
    rootReducer,
    loadState(),
    /*!isProduction && */composeWithDevtools(applyMiddleware(thunk))
)

store.subscribe(() => saveState({user: store.getState().user}))

const theme = createTheme();

export default function AppWrapper() {
    return (
        <ThemeProvider theme={theme}>
            <Provider store={store}>
                <Suspense fallback={<Loader/>}>
                    <App/>
                </Suspense>
            </Provider>
        </ThemeProvider>
    )
}